// TODO: this is just fakse, need to replace with real data once we have the videos ready
export default [
  { path: '/', id: 'XH-Onp8MzyI' },
  { path: '/fields', id: 'GW3fi4zB7iE' },
  { path: '/contracts', id: 'UhALBchLidc' },
  { path: '/storage', id: 'E1bwLrk_1qw' },
  { path: '/activity', id: 'I1AjjtSEs8U' },
];



// WEBPACK FOOTER //
// ./src/containers/OnboardingDropdown/videos.static.js